import { ONBOARDING_STEP, StepId } from "v2/components/onboarding/types";

export const ONBOARDING_STEP_KEY = {
  ENTITY_TYPE: "ENTITY_TYPE",
  PERSONAL_DETAILS: "PERSONAL_DETAILS",
  PHONE: "PHONE",
  CONFIRM_ENTITY: "CONFIRM_ENTITY",
  REVIEW_ENTITY: "REVIEW_ENTITY",
} as const;

export type OnboardingStepKey =
  (typeof ONBOARDING_STEP_KEY)[keyof typeof ONBOARDING_STEP_KEY];

const STEP_KEY_BY_ID: Record<StepId, OnboardingStepKey> = {
  [ONBOARDING_STEP.ENTITY_TYPE]: ONBOARDING_STEP_KEY.ENTITY_TYPE,
  [ONBOARDING_STEP.PERSONAL_DETAILS]: ONBOARDING_STEP_KEY.PERSONAL_DETAILS,
  [ONBOARDING_STEP.PHONE]: ONBOARDING_STEP_KEY.PHONE,
  [ONBOARDING_STEP.CONFIRM_ENTITY]: ONBOARDING_STEP_KEY.CONFIRM_ENTITY,
  [ONBOARDING_STEP.REVIEW_ENTITY]: ONBOARDING_STEP_KEY.REVIEW_ENTITY,
};

export const toStepKey = (id: StepId): OnboardingStepKey => STEP_KEY_BY_ID[id];
